import { ActivatedRoute } from '@angular/router';
import { Metadata, PropertyAreaUnitEnum } from '@classifieds-sell/datalayer';
import { ValidatorPipe } from '@classifieds-sell/shared';
import { getDifferenceDays } from './date.helper';
import { isEditPage, isRelistPage } from './router.helper';

export const validateLandAreaMaxValueByUnit =
    (draftData: any, validation: any, validatorPipe: ValidatorPipe) => {
        const propertyAreaUnitValue = draftData.propertyInformation.propertyAreaUnit;
        let minValue = validation.propertyInformation.propertyArea.validations.minValue.value;
        let maxValue = validation.propertyInformation.propertyArea.validations.maxValue.value;
        if (propertyAreaUnitValue === PropertyAreaUnitEnum.Acres) {
            maxValue = Math.floor(validation.propertyInformation.propertyArea.validations.maxValue.value / 0.404685642);
            minValue = Math.floor(validation.propertyInformation.propertyArea.validations.minValue.value / 0.404685642);
        }

        return validatorPipe.transform({
            name: 'Land area',
            validations: {
                required: validation.propertyInformation.propertyArea.validations.required,
                customValidation: {
                    errorMessage: `Land area must be between ${(minValue || 0).toLocaleString()} 
                        and ${(maxValue || 0).toLocaleString()}`,
                    enable: true,
                    validate: (propertyArea: number) => {
                        if (propertyArea < minValue || propertyArea > maxValue) {
                            return false;
                        }

                        return true;
                    }
                }
            }
        });
    };

export const isDisableInput = (route: ActivatedRoute, metadata: Metadata) => {
    if (isRelistPage(route)) {
        return true;
    }

    if (
        !isEditPage(route) ||
        !metadata ||
        !metadata.listingStartDate
    ) {
        return false;
    }

    const differenceDays = getDifferenceDays(
        new Date(),
        new Date(metadata.listingStartDate)
    );
    return differenceDays > 7;
};

